<script setup>
import { computed } from 'vue';

const props = defineProps({
  count: { type: [Number, String], default: 0 },
  active: { type: Boolean, default: false },
});

const normalizedCount = computed(() => {
  const count = Number(props.count);
  return Number.isFinite(count) && count > 0 ? count : 0;
});

const displayCount = computed(() =>
  normalizedCount.value > 99 ? '99+' : String(normalizedCount.value)
);
</script>

<template>
  <span
    v-if="normalizedCount > 0"
    data-test-id="sidebar-unread-badge"
    class="inline-grid h-5 min-w-5 place-items-center rounded-full px-1 text-xxs font-semibold leading-3 flex-shrink-0"
    :class="
      active
        ? 'bg-n-blue-9 text-white dark:bg-n-blue-9 dark:text-white'
        : 'bg-n-slate-3 text-n-slate-10 dark:bg-n-slate-4 dark:text-n-slate-10'
    "
  >
    {{ displayCount }}
  </span>
  <span v-else class="hidden" />
</template>
